/**
 * FAIR Toast — Figma PDP notes:
 * «по центру, 40px от нижней границы контента, на 3000 ms»
 * Visual = dark one-line Popover (check + Body-small).
 */

/** Auto-dismiss duration (ms). */
export const FAIR_TOAST_LIFE_MS = 3000

/** Distance from the bottom edge of the viewport / content (px). */
export const FAIR_TOAST_BOTTOM_OFFSET_PX = 40
